import { render, staticRenderFns } from "./AnBasisInformation.vue?vue&type=template&id=c88c54da&scoped=true&"
import script from "./AnBasisInformation.vue?vue&type=script&lang=js&"
export * from "./AnBasisInformation.vue?vue&type=script&lang=js&"
import style0 from "./AnBasisInformation.vue?vue&type=style&index=0&id=c88c54da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88c54da",
  null
  
)

export default component.exports